<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3 class="card-title">Daftar User</h3>
            </div>  
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card" v-if="$gate.isAdmin1()">
              <div class="card-header">
                <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Tambah User
                  </button>
                <div class="card-tools">
                  <input type="text" v-model="searchTerm"  placeholder="Cari">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <!--th>ID</th-->
                      <th role='button' v-on:click="sortRecords('username', 'users')">Username</th>
                      <th role='button' v-on:click="sortRecords('nama', 'unit_kerja')">Unit Kerja</th>
					  <th role='button' v-on:click="sortRecords('type', 'users')">Role</th>
                      <th role='button' v-on:click="sortRecords('name', 'users')">Nama</th>
                      <th role='button' v-on:click="sortRecords('phone', 'users')">HP/WA</th>
                      <th role='button' v-on:click="sortRecords('email', 'users')">Email</th>
                      <!--th>Email Verified?</th-->
                      <!--th>Created</th-->
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="user in users.data" :key="user.id">

                      <!--td>{{user.id}}</td-->
                      <td>{{user.username}}</td>
                      <td>{{user.nama_unit_kerja}}</td>
					  <td>{{ roleLabel(user.type) }}</td>
                      <td class="text-capitalize">{{user.name}}</td>
                      <td>{{user.phone}}</td>
                      <td>{{user.email}}</td>
                      <!--td :inner-html.prop="user.email_verified_at | yesno"></td-->
                      <!--td>{{user.created_at}}</td-->

                      <td>

                        <a href="#" @click="editModal(user)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                        /
                        <a href="#" @click="deleteUser(user.id)">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <div class="row">
                        <div class="col-6" style="margin-top:10px;">
                                Menampilkan <select v-model="pageShow" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Baris
                        </div>

                        <div class="col-6">
                            <pagination style="float:right;" :data="users" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div> 
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <div v-if="!$gate.isAdmin1()">
            <not-found></not-found>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Create New User</h5>
                    <h5 class="modal-title" v-show="editmode">Update User's Info</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateUser() : createUser()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Username</label>
                            <input v-model="form.username" type="text" name="username"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('username') }">
                            <has-error :form="form" field="username"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Name</label>
                            <input v-model="form.name" type="text" name="name"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>HP/WA (contoh : 6285711123456)</label>
                            <input v-model="form.phone" type="text" name="phone" @keyup="angka"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('phone') }">
                            <has-error :form="form" field="phone"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input v-model="form.email" type="text" name="email" @change="validasiEmail"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                            <has-error :form="form" field="email"></has-error>
                        </div>
                    
                        <div class="form-group">
                            <label>Password</label>
                            <input v-model="form.password" type="password" name="password"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('password') }" autocomplete="false">
                            <has-error :form="form" field="password"></has-error>
                        </div>
                    
                        <div class="form-group">
                            <label>User Role</label>
                            <select name="type" v-model="form.type" id="type" class="form-control" :class="{ 'is-invalid': form.errors.has('type') }">
                                <option value="">Select User Role</option>
                                <!--option value="admin">Admin</option-->
                                <option value="opd">Pengurus Barang Pengguna</option>
                                <!--option value="stafopd">Pengurus Barang</option-->
                                <!--option value="uptd">UPTD</option-->
                                <option value="stafuptd">Pengurus Barang Pembantu</option>
                                <option value="stafadminopd">Staf Admin OPD</option>
                                <option value="stafruang">User Ruangan</option>
                            </select>
                            <has-error :form="form" field="type"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Unit Kerja</label>
                            <select v-model="form.unit_kerja_id" name="unit_kerja_id" class="form-control" :class="{ 'is-invalid': form.errors.has('Unit Kerja') }">
                            <option v-for="unit_kerja in unit_kerjas" v-bind:value="unit_kerja.id">
                                {{ unit_kerja.nama }}
                            </option>

                            </select>
                            <has-error :form="form" field="unit_kerja_id"></has-error>
                        </div>
                    </div>                        
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Update</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Create</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                editmode: false,
                searchTerm:'',
                users : {},
                unit_kerjas : {},
                form: new Form({
                    id : '',
                    username : '',
                    type : '',
                    name: '',
                    phone: '',
                    email: '',
                    password: '',
                    unit_kerja_id: '',
                    ruang_id: '',
                    email_verified_at: '',
                }),
                sortIndex: 'username',
                sortDirection: 'asc',
                pageShow:10,
                showTable:'users'
            }
        },
        methods: {
			roleLabel(type) {
				const roles = {
					opd: 'Pengurus Barang Pengguna',
					stafopd: 'Pengurus Barang',
					uptd: 'UPTD',
					stafuptd: 'Pengurus Barang Pembantu',
					stafadminopd: 'Staf Admin OPD',
					stafruang: 'User Ruangan'
				};

				return roles[type] ?? type;
			},

            sortRecords (index, tableName) {
               
                this.sortIndex = index;
                this.showTable = tableName;
                if(this.sortDirection == 'asc'){
                   this.sortDirection = 'desc';
                }else if(this.sortDirection == 'desc'){
                   this.sortDirection = 'asc';
                }else{
                   this.sortDirection = 'asc';
                }
                
                this.$Progress.start();
                  
                axios.get('/api/user?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow + '&showTable=' + this.showTable).then(({ data }) => (this.users = data.data.users));

                this.$Progress.finish();
            },    
            changePageRange(){
                //alert(this.pageShow);
                this.$Progress.start();
                  
                  axios.get('/api/user?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow + '&showTable=' + this.showTable).then(({ data }) => (this.users = data.data.users));

                  this.$Progress.finish();
            },
            getResults(page = 1) {

                  this.$Progress.start();
                  
                  axios.get('/api/user?page=' + page + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow + '&showTable=' + this.showTable).then(({ data }) => (this.users = data.data.users));

                  this.$Progress.finish();
            },
            updateUser(){
                this.$Progress.start();
                // console.log('Editing data');
                this.form.put('api/user/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadUsers();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },
            editModal(user){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(user);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },
            deleteUser(id){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {

                        // Send request to the server
                         if (result.value) {
                                this.form.delete('api/user/'+id).then(()=>{
                                        Swal.fire(
                                        'Deleted!',
                                        'Your file has been deleted.',
                                        'success'
                                        );
                                    // Fire.$emit('AfterCreate');
                                    this.loadUsers();
                                }).catch((data)=> {
                                  Swal.fire("Failed!", data.message, "warning");
                              });
                         }
                    })
            },
            loadUsers(){
                this.$Progress.start();

                let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;
                if(this.$gate.isAdmin1()){
                    axios.get("/api/user?search=" + param + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow + '&showTable=' + this.showTable).then(({ data }) => (this.users = data.data.users,this.unit_kerjas = data.data.unit_kerja));
                }

                this.$Progress.finish();
            },
          
          createUser(){

              this.form.post('api/user')
              .then((response)=>{
                  $('#addNew').modal('hide');

                  Toast.fire({
                        icon: 'success',
                        title: response.data.message
                  });

                  this.$Progress.finish();
                  this.loadUsers();

              })
              .catch(()=>{

                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });
              })
          },
		  angka() {
                if (!/^[0-9]+$/.test(this.form.phone)) {
                    this.form.phone = this.form.phone.substring(0,this.form.phone.length-1);
                }
          },
          validasiEmail() {
                var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                if (filter.test(this.form.email)) {
                    return true;
                }else {
                    Swal.fire(
                                        'Format Email Tidak Sesuai !',
                                        'Email : '+this.form.email,
                                        'error'
                                        );
                    this.form.email = "";     
                }
          }

        },
        mounted() {
            console.log('User Component mounted.')
        },
        created() {

            this.$Progress.start();
            this.loadUsers();
            this.$Progress.finish();
        },
        watch: {
            searchTerm: function() {
                this.loadUsers();
            }
        }
    }
</script>
